module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/mv_heading-7c7d5f73c0f5a6f5c985827e2717bf1a.png";